<template>
  <b-row
    class="no-gutters min-vh-100 bg-blue text-white text-center p-3 w-100"
    align-v="center"
  >
    <div class="w-100">
      <div style="font-size: 30vh">
        404
      </div>

      <div class="text-h2" style="opacity:.4">
        Oops. Nothing here...
      </div>
    </div>
  </b-row>
</template>

<script>
export default {
  name: "Error404"
};
</script>
